export const mapLanguage = {
  "en-CA": "en-US",
  "fr-CA": "fr-FR",
  "en-NZ": "en-AU",
};
